import { Box, Switch, FormControlLabel } from '@mui/material';
import { translate } from '../translations/translator';
const t = key => translate('worksheet', key);

const HomepageContainer = ({ language, handleToggle }) => {
  return (
    <div
      className="homepage-container"
      id="Home-Tab-Panel"
      role="tabpanel"
      aria-labelledby="Home-Tab"
    >
      <div className="content">
        <div className="right-column">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              '@media (max-width: 600px)': {
                flexDirection: 'column'
              }
            }}
          >
            <h3 className="title">{t('homeTitle')}</h3>
            <span style={{ display: 'flex' }}>
              <FormControlLabel
                sx={{
                  height: 'max-content',
                  '@media (max-width: 400px)': {
                    flexDirection: 'column',
                    '& .MuiFormControlLabel-label': {
                      fontSize: '8px'
                    }
                  }
                }}
                control={
                  <Switch
                    defaultChecked
                    disableRipple
                    checked={language === 'ES_US'}
                    onChange={handleToggle}
                    inputProps={{ 'aria-label': t('switchLanguage') }}
                    color="primary"
                    sx={{
                      '& .MuiSwitch-input:focus + .MuiSwitch-thumb': {
                        outline: '3px solid #005fcc'
                      }
                    }}
                  />
                }
                label="Español"
              />
            </span>
          </Box>

          <ol className="content-list">
            <li>{t('homeBullet1')}</li>
            <li>{t('homeBullet2')}</li>
            <li dangerouslySetInnerHTML={{ __html: t('homeBullet3') }} />
            <li dangerouslySetInnerHTML={{ __html: t('homeBullet4') }} />
            <li dangerouslySetInnerHTML={{ __html: t('homeBullet5') }} />
            <li dangerouslySetInnerHTML={{ __html: t('homeBullet6') }} />
            <li dangerouslySetInnerHTML={{ __html: t('homeBullet7') }} />
          </ol>
        </div>
      </div>
    </div>
  );
};

export default HomepageContainer;
